<template>
    <div>
        <transition name="fade">
            <div class="room-intro-wrapper" v-show="isOpen" @click.stop="closeModal"></div>
        </transition>

        <div class="room-intro-container" :class="{'show':isOpen}">
            <!-- :style="{bottom: $route.name==='roomOrder'?'1.333333rem':0}" -->
            <div class="t-top">
                <span v-text="introData.name||introData.roomType"></span>
                <!-- <div class="close" @click.stop="closeModal">
                    <img :src="closeIconSrc" alt="close-icon">
                </div>-->
            </div>

            <div class="t-center" id="modal_scroll_container">
                <div class="swiper-wrapper" v-if="images.length>0">
                    <van-swipe :autoplay="3000" class="swiper-container" @change="onSwipeChange">
                        <van-swipe-item v-for="(image,index) in images" :key="index">
                            <img :src="image.url">
                        </van-swipe-item>
                        <template slot="indicator">
                            <div
                                class="custom-indicator"
                            >{{ (current + 1)>images.length?1:(current + 1) }}/{{images.length}}</div>
                        </template>
                    </van-swipe>
                </div>
                <div class="room-tags-wra" v-cloak>
                    <div class="intro-title">基本信息</div>
                    <div class="each-tags">
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.wifiName"
                        >{{introData.wifiName}}</div>
                        <div class="room-divider" v-if="introData.wifiName"></div>
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.hasWindowName"
                        >{{introData.hasWindowName}}</div>
                        <div
                            class="room-divider"
                            v-if="introData.hasWindowName && (introData.floor || introData.breakfastName || introData.area || introData.bedTypeName)"
                        ></div>
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.floor"
                        >{{introData.floor}}楼</div>
                        <div
                            class="room-divider"
                            v-if="introData.floor && (introData.breakfastName || introData.area || introData.bedTypeName)"
                        ></div>
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.breakfastName"
                        >{{introData.breakfastName}}</div>
                        <div
                            class="room-divider"
                            v-if="introData.breakfastName && (introData.area || introData.bedTypeName)"
                        ></div>
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.area"
                        >{{introData.area}}㎡</div>
                        <div class="room-divider" v-if="introData.area && introData.bedTypeName"></div>
                        <div
                            class="each-tag text-overflow"
                            v-if="introData.bedTypeName"
                        >{{introData.bedTypeName}}</div>
                    </div>
                </div>
                <div class="each-intro" v-if="introData.introduction">
                    <div class="intro-title">房型说明</div>
                    <div class="intro-row" v-text="introData.introduction"></div>
                </div>
                <div class="each-intro" v-if="introData.orderTip">
                    <div class="intro-title">预订须知</div>
                    <div class="intro-row" v-text="introData.orderTip"></div>
                </div>

                <div class="each-intro" v-if="introData.refundRule">
                    <div class="intro-title">退款规则</div>
                    <div class="intro-row" v-text="introData.refundRule"></div>
                </div>
            </div>
            <div class="t-bottom" v-if="isShowBottom">
                <div class="price">￥{{item.salePrice}}</div>
                <div class="yd-btn" @click.stop="goToOrder(item.id)">立即预定</div>
            </div>
        </div>
    </div>
</template>

<script>
import MODAL_MIXINS from "@/components/common/ModalCommonMixins";
export default {
    name: "RoomIntroModal",
    components: {},
    props: {
        isShowBottom: Boolean,
        item: Object
    },
    mixins: [MODAL_MIXINS],
    data() {
        return {
            current: 0,
            closeIconSrc: ""
        };
    },
    computed: {
        introData() {
            return this.item.detail || this.item;
        },
        images() {
            return this.introData.images || [];
        }
    },
    watch: {},
    created() {},
    mounted() {
        this.closeIconSrc = API.ossUrl + "scene/png/close-icon.png";
    },
    destroyed() {},
    activated() {
        this.current = 0;
    },
    methods: {
        onSwipeChange(index) {
            this.current = index;
        },
        goToOrder(roomId) {
            this.$router.push({
                name: "roomOrder",
                params: {
                    roomId
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.room-intro-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.65);
    z-index: 10000;
}
.room-intro-container {
    position: fixed;
    left: 0px;
    bottom: 0;
    width: 100%;
    background: $white;
    z-index: 10002;
    height: $modal-height;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    white-space: pre-line;
    word-break: break-word;
    overflow: auto;
    -webkit-overflow-scrolling: touch;    
    &.show {
        transform: translate(0, 0);
    }
    .swiper-wrapper {
        width: 8.9333rem;
        height: 4.48rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 16px 0px rgba(174, 174, 174, 0.25);
        border-radius: 0.266667rem;
        margin: 0 auto;
        .swiper-container {
            height: 100%;
            width: 8.9333rem;
            border-radius: 0.266667rem;
        }
    }
    .t-top {
        height: 1.146667rem;
        line-height: 1.146667rem;
        color: #333;
        font-size: 16px;
        padding-left: 0.4rem;
        position: relative;
        flex: none;
        span {
            font-weight: bold;
        }
        .close {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 0;
            top: 0;
            width: 1.44rem;
            height: 100%;
            img {
                width: 0.426667rem;
                height: 0.426667rem;
            }
        }
    }
    .t-center {
        // height: 10.586667rem;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        flex: auto;
        height: 100%;
        padding-bottom: 1.333333rem;
        .room-tags-wra {
            margin-top: 0.5333rem;
            padding: 0 0.266667rem;
            .intro-title {
                font-size: 0.4267rem;
                color: #444444;
                font-weight: bold;
            }
            .each-tags {
                display: flex;
                align-items: baseline;
                flex-wrap: wrap;
                margin-top: 0.2667rem;
                padding-left: 0.16rem;
                .each-tag {
                    margin-top: 0.2667rem;
                    font-size: 0.3733rem;
                    &.intro {
                        width: 100%;
                    }
                }
                .room-divider {
                    width: 1px;
                    height: 0.32rem;
                    background-color: #d8d8d8;
                    margin: 0 0.6933rem;
                }
            }
        }
        .each-intro {
            margin-top: 0.5333rem;
            padding-left: 0.5333rem;
            .intro-title {
                font-size: 0.4267rem;
                color: #444444;
                font-weight: bold;
            }
            .intro-row {
                margin-top: 0.5333rem;
                font-size: 0.3733rem;
                padding: 0 0.3733rem;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #444444;
            }
        }
    }
    .t-bottom {
        height: 1.333333rem;
        padding-left: 0.44rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: -1px -1px 10px rgba(0, 0, 0, 0.09);
        flex: none;
        .price {
            color: $orange;
            font-size: 21px;
            font-weight: bold;
        }
        .yd-btn {
            margin-right: 0.533333rem;
            width: 4.8rem;
            height: 1.066667rem;
            line-height: 1.066667rem;
            font-size: 16px;
            text-align: center;
            background: linear-gradient(
                90deg,
                rgba(248, 199, 64, 1) 0%,
                rgba(245, 149, 38, 1) 100%
            );
            border-radius: 0.533333rem;
            color: $white;
            font-weight: bold;
        }
    }
}
</style>

